import React from 'react';
import DialogComponent from './dialog/dialog.component';
import i18n from '../i18n';

interface PdfPreviewDialogProps {
    open: boolean;
    onClose: () => void;
    url?: string;
    title?: string;
}

const PdfPreviewDialog: React.FC<PdfPreviewDialogProps> = ({
    open,
    onClose,
    url,
    title,
}) => {
    return (
        <DialogComponent
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth='lg'
            heightSize='large'
            title={title || i18n.t('general_text_preview')}
        >
            {url && (
                <iframe
                    src={url}
                    title='PDF Preview'
                    style={{ width: '100%', height: 'calc(100vh - 183px)', border: 'none' }}
                    allowFullScreen
                ></iframe>
            )}
        </DialogComponent>
    );
};

export default PdfPreviewDialog;
